var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"container-height",staticStyle:{"border":"0","padding":"0","margin":"0"},attrs:{"src":"https://jp-prototypes-v4.pages.dev/html/dashboard/designs","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }